<template>
  <div>
    <b-row class="mb-1">
      <b-col md="4" class="mb-md-0 mr-5 mt-1 d-flex align-items-center ">
        <b-button variant="gradient-danger" @click="goBack">
          <feather-icon icon="ArrowLeftIcon" class="mr-50" />
          <span class="align-middle">Atras</span>
        </b-button>
      </b-col>
      
      <b-col md="2" class="mb-md-0 ">
        <label>Local Actual</label>
        <b-form-input :value="localName" readonly />
      </b-col>
      <b-col class="d-flex align-items-center justify-content-end mt-1">
        <b-button variant="primary" @click="confirmSave">
          <span class="text-nowrap">Guardar</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card class="mb-4">
      <b-card-header>
        <h4 class="mb-0">Tabla de Comprobantes</h4>
      </b-card-header>
      <b-card-body>
        <b-table :items="tableData" :fields="fields" responsive>
          <template #cell(typeDoc)="row">
            <b-form-input
              v-model="row.item.typeDoc"
              :disabled="row.item.isAdded"
              placeholder="Ingrese el tipo de comprobante"
            />
          </template>
          <template #cell(numeral)="row">
            <b-form-input
              v-model="row.item.numeral"
              :disabled="row.item.isAdded"
              placeholder="Ingrese el numeral"
            />
          </template>
          <template #cell(actions)="row">
            <b-button
              v-if="!row.item.isAdded"
              variant="primary"
              size="sm"
              @click="addRow(row.index)"
              :disabled="!isRowValid(row.item)"
            >
              Añadir
            </b-button>
            <b-button
              v-else
              variant="danger"
              size="sm"
              @click="deleteRow(row.index)"
            >
              Eliminar
            </b-button>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import VoucherService from "@/services/VoucherService";
import StoresService from "@/services/StoresService";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      showLoading: false,
      establishmentId: null,
      localName: "",
      tableData: [],
      fields: [
        { key: "typeDoc", label: "Tipo de Comprobante" },
        { key: "numeral", label: "Numeral" },
        { key: "actions", label: "Acciones" },
      ],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: "id",
      order: "desc",
    };
  },
  mounted() {
    this.loadVouchers();
    this.loadLocalName();
  },
  methods: {
    async loadLocalName() {
      try {
        const id = parseInt(this.$route.params.id);
        const resp = await StoresService.getStore(id, this.$store);
        if (resp && resp.data) {
          this.localName = resp.data.name;
        }
      } catch (error) {
        console.error("Error al cargar nombre del local:", error);
        this.localName = "No disponible";
      }
    },

    async loadVouchers() {
      this.showLoading = true;
      this.tableData = [];
      this.arrayFilters = [];
      this.totalElements = 0;
      this.arrayFilters.push({
        keyContains: "establishmentId",
        key: "equals",
        value: parseInt(this.$route.params.id),
      });
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${
        this.order
      }&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;

      const resp = await VoucherService.getVouchers(url, this.$store);
      console.log("response: ", resp);
      if (resp.data && resp.data.rows.length > 0) {
        this.tableData = resp.data.rows.map((row) => ({
          ...row,
          isAdded: true,
        }));
        this.tableData.push({ typeDoc: "", numeral: "", isAdded: false });
        this.totalElements = resp.itemCount;
      } else {
        this.tableData.push({ typeDoc: "", numeral: "", isAdded: false });
      }

      this.showLoading = false;
    },

    isRowValid(row) {
      return row.typeDoc.trim() !== "" && row.numeral.trim() !== "";
    },
    addRow(index) {
      this.tableData[index].isAdded = true;
      this.tableData.push({ typeDoc: "", numeral: "", isAdded: false });
    },
    deleteRow(index) {
      this.tableData.splice(index, 1);
    },
    goBack() {
      this.$router.go(-1);
    },
    confirmSave() {
      this.$swal({
        title: "¿Guardar comprobantes?",
        text: "Esta acción guardará todos los comprobantes añadidos.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, guardar",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-secondary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.saveData();
          this.$swal({
            title: "Guardado",
            text: "Los comprobantes han sido guardados exitosamente.",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.$router.push("/locales/listar");
        }
      });
    },
    async saveData() {
      const addedRows = this.tableData.filter((row) => row.isAdded);

      const payload = {
        establishmentId: parseInt(this.$route.params.id),
        vouchers: addedRows.map((row) => ({
          typeDoc: row.typeDoc,
          numeral: row.numeral,
        })),
      };

      const response = await VoucherService.saveVoucher(payload, this.$store);
      console.log("respuesta", response);
    },
  },
};
</script>
